export default class MainVisual {
  /**
   * @param {Object} options
   * @param {string} options.keyVisualSelector
   * @param {Array}  options.intervieweeNameImages
   * @param {Object} options.intervieweePhotoImage
   */
  constructor({
    keyVisualSelector,
    intervieweeNameImages,
    intervieweePhotoImage,
  } = {}) {
    this.keyVisualSelector = keyVisualSelector;
    this.intervieweeNameImages = intervieweeNameImages;

    /**
     * images data
     * tx, ty: 画像の表示位置(1440px x 100pxとしたときの座標)
     * src: 画像のURL
     */
    this.logoImage = {
      src: "/ns_mikinorihei_takadafumio/imgs_main/logo_hobo.png",
      tx: 360,
      ty: 112,
      w: 122,
      h: 60,
      mtx: 0,
      mty: 0,
      mw: 61,
      mh: 30,
    };
    this.titleTextImages = {
      top: [
        {
          src: "/ns_mikinorihei_takadafumio/imgs_main/str_0-0.png",
          tx: 376,
          ty: 180,
          w: 102,
          h: 102,
          mtx: 348,
          mty: 0,
          mw: 68,
          mh: 68,
        },
        {
          src: "/ns_mikinorihei_takadafumio/imgs_main/str_0-1.png",
          tx: 498,
          ty: 180,
          w: 102,
          h: 102,
          mtx: 348,
          mty: 68,
          mw: 68,
          mh: 68,
        },
        {
          src: "/ns_mikinorihei_takadafumio/imgs_main/str_0-2.png",
          tx: 620,
          ty: 180,
          w: 102,
          h: 102,
          mtx: 348,
          mty: 136,
          mw: 68,
          mh: 68,
        },
        {
          src: "/ns_mikinorihei_takadafumio/imgs_main/str_0-3.png",
          tx: 742,
          ty: 180,
          w: 78,
          h: 102,
          mtx: 356,
          mty: 204,
          mw: 52,
          mh: 68,
        },
        {
          src: "/ns_mikinorihei_takadafumio/imgs_main/str_0-4.png",
          tx: 840,
          ty: 180,
          w: 102,
          h: 102,
          mtx: 348,
          mty: 272,
          mw: 68,
          mh: 68,
        },
        {
          src: "/ns_mikinorihei_takadafumio/imgs_main/str_0-5.png",
          tx: 962,
          ty: 180,
          w: 102,
          h: 102,
          mtx: 348,
          mty: 340,
          mw: 68,
          mh: 68,
        },
      ],
      bottom: [
        {
          src: "/ns_mikinorihei_takadafumio/imgs_main/str_1-0.png",
          tx: 376,
          ty: 778,
          w: 102,
          h: 102,
          mtx: 348,
          mty: 408,
          mw: 68,
          mh: 68,
        },
        {
          src: "/ns_mikinorihei_takadafumio/imgs_main/str_1-1.png",
          tx: 530.75,
          ty: 778,
          w: 102,
          h: 102,
          mtx: 348,
          mty: 476,
          mw: 68,
          mh: 68,
        },
        {
          src: "/ns_mikinorihei_takadafumio/imgs_main/str_1-2.png",
          tx: 685.5,
          ty: 778,
          w: 102,
          h: 102,
          mtx: 348,
          mty: 544,
          mw: 68,
          mh: 68,
        },
        {
          src: "/ns_mikinorihei_takadafumio/imgs_main/str_1-3.png",
          tx: 840.5,
          ty: 778,
          w: 102,
          h: 102,
          mtx: 348,
          mty: 612,
          mw: 68,
          mh: 68,
        },
        {
          src: "/ns_mikinorihei_takadafumio/imgs_main/str_1-4.png",
          tx: 995,
          ty: 778,
          w: 69,
          h: 102,
          mtx: 359,
          mty: 680,
          mw: 46,
          mh: 68,
        },
      ],
    };
    this.titlePhotoImages = [
      {
        src: "/ns_mikinorihei_takadafumio/imgs_main/ph_main_miki.jpg",
        tx: 360,
        ty: 290,
        w: 360,
        h: 480,
        mtx: 0,
        mty: 0,
        mw: 280,
        mh: 374,
      },
      intervieweePhotoImage,
    ];

    // デバイス判定と論理解像度設定
    const isSp = document.body.classList.contains("is_sp");
    this._DPR = isSp ? 3 : 2;
    this._baseWidth = isSp ? 416 : 1440;
    this._baseHeight = isSp ? 748 : 1000;

    this.#initCanvas();
    this.#loadAllImages().then(() => {
      this.#setupAnimations();
      requestAnimationFrame(this.#animate.bind(this));
      setInterval(this.#idleWobble.bind(this), 5000);
    });
  }

  /** Canvas 初期化 */
  #initCanvas() {
    const c = document.createElement("canvas");
    c.id = "key-visual";
    c.width = this._baseWidth * this._DPR;
    c.height = this._baseHeight * this._DPR;

    // 画面内に必ず収まるように contain 相当のスタイルを適用
    c.style.display = "block"; // ブロック要素化して余白を消す
    c.style.width = "100vw"; // ビューポート幅いっぱい
    c.style.height = "100vh"; // ビューポート高さいっぱい
    c.style.objectFit = "contain"; // アスペクト比を維持してコンテナに収める
    c.style.maxWidth = "100%"; // 念のため親要素の幅も超えない
    if (document.body.classList.contains("is_sp")) {
      c.style.maxHeight = "100%"; // 念のため親要素の高さも超えない
    } else {
      c.style.maxHeight = "62.5vw"; // 横幅の62.5%を最大高さに設定
    }
    if (document.body.classList.contains("is_sp")) {
      c.style.objectPosition = "left";
    }

    document.querySelector(this.keyVisualSelector).appendChild(c);

    this.ctx = c.getContext("2d");
    this.ctx.scale(this._DPR, this._DPR);
    this.ctx.imageSmoothingEnabled = true; // 画像のスムージングを有効化
  }

  /** 画像プリロード */
  #loadAllImages() {
    const list = [
      this.logoImage,
      ...this.titlePhotoImages,
      ...Object.values(this.titleTextImages).flat(),
      ...this.intervieweeNameImages,
    ].filter((i) => i && i.src);
    return Promise.all(
      list.map(
        ({ src }) =>
          new Promise((res) => {
            const img = new Image();
            img.onload = img.onerror = () => res();
            img.src = src;
          })
      )
    );
  }

  /** アニメーションデータ生成 */
  #setupAnimations() {
    const now = performance.now();
    const dpr = this._DPR;
    const canvasW = this.ctx.canvas.width / dpr;
    const canvasH = this.ctx.canvas.height / dpr;
    const isSp = document.body.classList.contains("is_sp");

    const pick = (data) => ({
      tx: isSp && data.mtx != null ? data.mtx : data.tx,
      ty: isSp && data.mty != null ? data.mty : data.ty,
      w: isSp && data.mw != null ? data.mw : data.w,
      h: isSp && data.mh != null ? data.mh : data.h,
    });
    const randRot = () => ((Math.random() * 90 - 45) * Math.PI) / 180;

    this._items = [];

    // 2. titlePhotoImages
    this.titlePhotoImages.forEach((data, i) => {
      const img = new Image();
      img.src = data.src;
      const { tx, ty, w, h } = pick(data);
      this._items.push({
        img,
        tx,
        ty,
        w,
        h,
        sx: tx,
        sy: ty,
        rot0: 0,
        rot1: 0,
        rotEnabled: false,
        wobbleEnabled: false,
        start: now + 200 + i * 50,
        dur: 1000,
        type: "fade",
      });
    });
    // 3. titleTextImages
    this.titleTextImages.top
      .concat(this.titleTextImages.bottom)
      .forEach((data, i) => {
        const img = new Image();
        img.src = data.src;
        const { tx, ty, w, h } = pick(data);
        const sx = Math.random() * canvasW,
          sy = Math.random() * canvasH;
        this._items.push({
          img,
          tx,
          ty,
          w,
          h,
          sx,
          sy,
          rot0: randRot(),
          rot1: 0,
          rotEnabled: true,
          wobbleEnabled: true,
          start: now + 400 + i * 30,
          dur: 2400,
          type: "move",
        });
      });
    // 4. intervieweeNameImages
    this.intervieweeNameImages.forEach((data, i) => {
      const img = new Image();
      img.src = data.src;
      const { tx, ty, w, h } = pick(data);
      const sx = Math.random() * canvasW,
        sy = Math.random() * canvasH;
      this._items.push({
        img,
        tx,
        ty,
        w,
        h,
        sx,
        sy,
        rot0: randRot(),
        rot1: 0,
        rotEnabled: true,
        wobbleEnabled: true,
        start: now + 800 + i * 30,
        dur: 2400,
        type: "move",
      });
    });
    // 1. logoImage
    {
      const data = this.logoImage;
      const img = new Image();
      img.src = data.src;
      const { tx, ty, w, h } = pick(data);
      this._items.push({
        img,
        tx,
        ty,
        w,
        h,
        sx: tx,
        sy: ty,
        rot0: randRot(),
        rot1: 0,
        rotEnabled: true,
        wobbleEnabled: true,
        start: now,
        dur: 800,
        type: "fade",
      });
    }

    this._items.forEach((item) => {
      item.baseX = item.tx;
      item.baseY = item.ty;
      item._wobblePhase = 0; // 0=idle,1=振動→,2=戻り
    });
  }

  /** アニメーションループ */
  #animate(now) {
    const ctx = this.ctx;
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    let running = false;

    this._items.forEach((item) => {
      const t0 = (now - item.start) / item.dur;
      const t = Math.min(Math.max(t0, 0), 1);
      if (t < 1 || item._wobblePhase === 1) running = true;

      const e =
        item._wobblePhase === 1 || item._wobblePhase === 2
          ? this.#easeInOutQuad(t)
          : this.#easeElasticOut(t);

      const x = item.sx + (item.tx - item.sx) * e;
      const y = item.sy + (item.ty - item.sy) * e;
      const rot = item.rot0 + (item.rot1 - item.rot0) * e;

      ctx.save();
      ctx.globalAlpha = item._wobblePhase > 0 ? 1 : e;
      ctx.translate(x + item.w / 2, y + item.h / 2);
      if (item.rotEnabled) ctx.rotate(rot);
      ctx.drawImage(item.img, -item.w / 2, -item.h / 2, item.w, item.h);
      ctx.restore();

      // フェーズ1完了 → フェーズ2(戻る)へ
      if (item.wobbleEnabled && item._wobblePhase === 1 && t >= 1) {
        item._wobblePhase = 2;
        // フェーズ1で終点だった角度を rot0 にセット→フェーズ2で0へ戻る
        item.rot0 = item.rot1;
        item.rot1 = 0;
        // 位置を元の baseX/Y へ戻す
        item.sx = item.tx;
        item.sy = item.ty;
        item.tx = item.baseX;
        item.ty = item.baseY;
        item.start = now;
        item.dur = 2400;
        running = true;
      }
      // フェーズ2完了 → wobble 終了
      else if (item._wobblePhase === 2 && t >= 1) {
        item._wobblePhase = 0;
      }
    });

    if (running) {
      requestAnimationFrame(this.#animate.bind(this));
    }
  }

  /** アイドル時ゆらぎ */
  #idleWobble() {
    const now = performance.now();
    this._items.forEach((item) => {
      if (!item.wobbleEnabled) return;
      const dx = (Math.random() * 2 - 1) * 20;
      const dy = (Math.random() * 2 - 1) * 20;
      const drot = item.rotEnabled
        ? ((Math.random() * 2 - 1) * 10 * Math.PI) / 180
        : 0;

      item._wobblePhase = 1;
      item.sx = item.baseX;
      item.sy = item.baseY;
      item.tx = item.baseX + dx;
      item.ty = item.baseY + dy;
      // ★ フェーズ1で 0 → drot に回転
      item.rot0 = 0;
      item.rot1 = drot;
      item.start = now;
      item.dur = 2400;
    });
    requestAnimationFrame(this.#animate.bind(this));
  }

  /** Elastic Out イージング */
  #easeElasticOut(t) {
    const period = 0.98,
      s = period / 4;
    if (t === 0) return 0;
    if (t === 1) return 1;
    return (
      Math.pow(2, -10 * t) * Math.sin(((t - s) * 2 * Math.PI) / period) + 1
    );
  }

  /** Quad InOut イージング（緩やかな入り→アウト） */
  #easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }

  /** Quad Out イージング（緩やかなアウト） */
  #easeOutQuad(t) {
    return -t * (t - 2);
  }
}
